import styled from 'styled-components';
import { color } from 'styles/Theme';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	align-items: center;
	//padding: 0.5rem;
	//background: ${color.interface.beige};
	border-radius: 6px;
`;

export const Buttons = styled.div`
	display: flex;
	width: 100%;
	justify-content: space-around;
	min-width: 0;
`;

export const UploadButton = styled.button`
	display: flex;
	align-items: center;
	gap: 0.5rem;
	padding: 0.75rem 1.5rem;
	background: ${(props) => (props.disabled ? color.interface.lightGray2 : color.interface.orange)};
	color: ${color.interface.white};
	border: none;
	border-radius: 6px;
	font-weight: 600;
	cursor: pointer;
	transition: background 0.2s;

	&:hover:not(:disabled) {
		background: ${color.auxiliary.darkCoral};
	}

	svg {
		font-size: 1.25rem;
	}
`;

export const SubmitButton = styled.button`
	padding: 0.75rem 2rem;
	background: ${(props) => (props.disabled ? color.interface.lightGray2 : color.interface.green)};
	color: ${color.interface.white};
	border: none;
	border-radius: 6px;
	font-weight: 600;
	cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
	transition: background 0.2s;

	&:hover:not(:disabled) {
		background: ${color.interface.darkGreen};
	}
`;

export const FileName = styled.span`
	color: ${color.interface.darkGray};
	font-size: 0.875rem;
	max-width: 300px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	flex-shrink: 1;
`;

export const InvalidFormat = styled.span`
	color: ${color.interface.red};
	font-size: 0.875rem;
`;
